<template>
  <div class="teamWarp" :style="showAddNewGroup ? '' : `${isCheck ? '' : 'border-top: 0.026rem solid #C9C9C9 !important;'}padding-top: 0.4rem;margin-top: 0.2rem;`">
    <div>
      <div class="lineContent" v-if="!personalMessage">
        <div class="name nameSpace">团队名称:</div>
        <el-input v-model="team.orgName" placeholder="请输入团队名称" :disabled="!showAddNewGroup" :maxlength="'20'"></el-input>
      </div>
      <div class="lineContent">
        <div class="name">{{!personalMessage ? '团队负责人:' : '姓名'}}</div>
        <el-input v-model="team.personName" placeholder="请输入团队负责人" :disabled="team.disabled || !showAddNewGroup"></el-input>
      </div>
      <div class="lineContent">
        <div class="name nameSpace">证件号码:</div>
        <el-input v-model="team.cardNum" placeholder="请输入证件号码" :disabled="team.disabled && team.cardType == 1 || !showAddNewGroup"></el-input>
      </div>
      <div class="lineContent">
        <div class="name nameSpace">联系电话:</div>
        <el-input v-model="team.phone" placeholder="请输入联系电话" :disabled="team.disabled || !showAddNewGroup"></el-input>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    };
  },

  props: ['team', 'showAddNewGroup', 'museumCode', 'personalMessage', 'isCheck'],

  methods: {
  },

  created() {
    this.actionUrl = Glob.baseUrl + '/api/file/upload/'
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
  .teamWarp{
    .buttonLeft{
      margin-left: -1rem;
    }
    .lastLine{
      margin-top: 0.2rem;
    }
    .itemCard{
      padding-top: 0.5rem !important;
    }
    .nameSpace{
      letter-spacing: 0.24em;
    }
    .lineContent{
      margin-bottom: 0.1rem;
    }
  }
</style>
